import { faAngleDown } from "@jewlr/pro-regular-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-regular-svg-icons/faAngleUp"
import PropTypes from "prop-types"
import { useState } from "react"

import Button from "components/ui/button"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

import WhyContent from "./why_choose_jewlr-content"

const Whydropdown = ({ whyCategory, index }) => {
  const [show, setShow] = useState(false)
  return (
    <div className="border-b-grey-10 border-b last:border-b-0">
      <Button
        className="text-24 w-full justify-between px-16 py-24"
        onClick={(e) => {
          e.stopPropagation
          setShow(!show)
        }}
      >
        <p className="text-primary text-16 tablet:text-18 tablet:font-light">
          <span className="text-primary text-32 tablet:ml-16 tablet:mr-20 float-left -mt-4">
            {index + 1} &nbsp;
          </span>
          {whyCategory.title}
        </p>
        <FontAwesomeIcon
          className="text-primary"
          icon={show ? faAngleUp : faAngleDown}
        />
      </Button>
      <Expand className="" show={show}>
        {whyCategory.why.map((q, i) => (
          <WhyContent key={`whycontent${i}`} why={q} />
        ))}
      </Expand>
    </div>
  )
}

Whydropdown.propTypes = {
  index: PropTypes.number,
  whyCategory: PropTypes.object,
}

export default Whydropdown
